export const CORTEX_DEFAULT_PORT = 39291

export const LOCAL_HOST = '127.0.0.1'

export const SUPPORTED_MODEL_FORMAT = '.gguf'

export const CORTEX_API_URL = `http://${LOCAL_HOST}:${CORTEX_DEFAULT_PORT}/v1`
